export default "/_next/static/chunks/fonts/Foundation-c0cbb004854f9c746f89e17ab5969370.ttf";